import axios from 'axios';

const API_URL = 'http://localhost:5193/api';

/**
 * AI Assistant API servisi - Gemini destekli chatbot
 * Backend: /api/Assistant/Chat endpoint'i
 */

/**
 * Chat mesajı gönder
 * @param {string} message - Kullanıcı mesajı
 * @param {Array} conversationHistory - Önceki mesajlar (opsiyonel)
 * @param {Object} context - İstek bağlamı
 * @returns {Promise<Object>} API yanıtı
 */
export const sendChatMessage = async (message, conversationHistory = [], context = {}) => {
  try {
    const messages = [
      {
        role: 'system',
        content: 'Sen İskenderun Belediyesi web sitesi asistanısın.'
      },
      ...conversationHistory,
      {
        role: 'user',
        content: message
      }
    ];

    const payload = {
      messages,
      context: {
        site: context.site || 'https://iskenderun.bel.tr',
        locale: context.locale || 'tr-TR',
        voiceEnabled: context.voiceEnabled || false,
        screen: context.screen || 'desktop'
      }
    };

    console.log('[ASSISTANT] Sending request:', { 
      message, 
      url: `${API_URL}/Assistant/Chat`,
      payloadSize: JSON.stringify(payload).length 
    });
    
    const response = await axios.post(`${API_URL}/Assistant/Chat`, payload);
    
    // DEBUG mesajlarını kontrol et
    if (response.data?.data?.reply) {
      const debugMatch = response.data.data.reply.match(/\[DEBUG:([^\]]+)\]/);
      if (debugMatch) {
        console.warn('[ASSISTANT] Backend DEBUG:', debugMatch[1].trim());
      }
    }
    
    console.log('[ASSISTANT] Response received:', {
      isSuccess: response.data?.isSuccess,
      statusCode: response.data?.statusCode,
      replyLength: response.data?.data?.reply?.length || 0,
      hasLinks: response.data?.data?.links?.length > 0,
      intents: response.data?.data?.intents
    });
    
    return response.data;
  } catch (error) {
    console.error('[ASSISTANT] Error sending chat message:', error);
    throw error;
  }
};

/**
 * Assistant sağlık kontrolü
 * @returns {Promise<boolean>}
 */
export const checkAssistantHealth = async () => {
  try {
    const response = await axios.get(`${API_URL}/Assistant/Health`);
    return response.data === true || response.data?.status === 'ok';
  } catch (error) {
    console.error('[ASSISTANT] Health check failed:', error);
    return false;
  }
};

/**
 * Hızlı işlem butonları - Site sayfalarına yönlendirme
 */
export const QUICK_ACTIONS = [
  { id: 'bize-bildir', title: 'Bize Bildir', icon: '📝', url: '/bize-bildir', action: 'navigate' },
  { id: 'e-belediye', title: 'E-Belediye Ödeme', icon: '💳', url: '/e-belediye/odeme', action: 'navigate' },
  { id: 'ihale', title: 'İhale & Duyuru', icon: '📢', url: '/ihale-duyurular', action: 'navigate' },
  { id: 'etkinlik', title: 'Etkinlikler', icon: '🎉', url: '/etkinlikler', action: 'navigate' },
  { id: 'meclis', title: 'Meclis Kararları', icon: '📋', url: '/meclis-kararlari', action: 'navigate' },
  { id: 'imar', title: 'İmar Sorgu', icon: '🏗️', url: '/e-belediye/imar', action: 'navigate' },
  { id: 'nikah', title: 'Nikâh İşlemleri', icon: '💍', url: '/nikah-islemleri', action: 'navigate' },
  { id: 'eczane', title: 'Nöbetçi Eczane', icon: '⚕️', url: '/nobetci-eczane', action: 'modal' }
];
